import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import Swal from 'sweetalert2';
import { Search } from '../../models/input-filter-form.model';

@Component({
    selector: 'app-input-filter-form',
    templateUrl: './input-filter-form.component.html',
    styleUrls: ['./input-filter-form.component.scss'],
    standalone: false
})
export class InputFilterFormComponent {
	@Input() listSearch: Array<Search> = [];
	@Output() submitEvent = new EventEmitter<Search>();
	searchTerm = new UntypedFormControl();
	search!: Search;

	constructor() {}

	setTypeSearch(search: Search) {
		this.search = search;
	}

	submitSearch() {
		if (!this.search) {
			Swal.fire({
				title: '¡Atención!',
				text: `Elige un filtro para buscar`,
				icon: 'warning',
				confirmButtonText: 'Ok',
				buttonsStyling: false,
				customClass: {
					confirmButton: 'btn btn-primary',
				},
			}).then(result => {});
			return;
		}
		this.submitEvent.emit({ ...this.search, term: this.searchTerm.value });
	}
}
